<template>
  <div
    class="generate-result height-all"
    :class="`generate-result--${createRenderType} generate-result--${renderData.listRenderType}`"
  >
    <div
      class="height-all"
      v-if="
        !renderData.hasInit &&
        !renderData.datas?.length &&
        !['mysong', 'likemysong', 'dislikemysong', 'publishedmysong'].includes(
          renderData.listRenderType
        )
      "
    >
      <EmptyNoLogin
        v-if="
          isCreatePage &&
          renderData.demoSongData?.length &&
          renderData.listRenderType == 'createdresult' &&
          ![
            'mysong',
            'likemysong',
            'dislikemysong',
            'publishedmysong',
          ].includes(renderData.listRenderType) &&
          (createEditMode != 'hard' || createRenderType == 'mobile') &&
          renderData.mounted
        "
        :datas="renderData.demoSongData"
      ></EmptyNoLogin>

      <CreateGuid
        v-if="
          isCreatePage &&
          renderData.demoSongData?.length &&
          renderData.listRenderType == 'createdresult' &&
          ![
            'mysong',
            'likemysong',
            'dislikemysong',
            'publishedmysong',
          ].includes(renderData.listRenderType) &&
          createEditMode == 'hard' &&
          createRenderType != 'mobile'
        "
      ></CreateGuid>

      <QueryEmptyRetry
        v-if="
          (!(
            renderData.demoSongData?.length &&
            renderData.listRenderType == 'createdresult' &&
            ![
              'mysong',
              'likemysong',
              'dislikemysong',
              'publishedmysong',
            ].includes(renderData.listRenderType)
          ) ||
            !isCreatePage) &&
          renderData.ifRenderEmpty
        "
        :info="renderData.emptyInfo"
        :type="renderData.loadError ? 'loadfailure' : 'emptydata'"
        @retry="
          () => {
            doRetry(true);
          }
        "
      ></QueryEmptyRetry>
    </div>

    <div class="height-all generate-result-main" v-else>
      <div
        class="generate-result-search flex"
        :class="{
          'generate-result-search--opened': renderData.filterOpened,
          'generate-result-search--closed': !renderData.filterOpened,
        }"
      >
        <!-- <div
          class="generate-result-search-title-count"
          v-if="
            createRenderType != 'mobile' &&
            ['mysong', 'likemysong', 'dislikemysong', 'publishedmysong'].includes(
              renderData.listRenderType
            )
          "
        >
          {{
            $$tValue("create.song_counts", {
              num: renderData.total > 999 ? "999+" : renderData.total,
            })
          }}
        </div> -->
        <div class="flex1 flex generate-result-search-search-box">
          <div class="generate-result-search-search flex1">
            <Search
              v-if="renderData.ifRender"
              ref="refSearchInput"
              :renderStyle="{
                '--height': '100%',
                '--padding':
                  createRenderType == 'mobile' ? '0 1px 0 9px' : '0 9px',
                '--borderRadius': '60px',
                '--border': 'solid 1px transparent',
                '--focusBorder': '1px solid #94ADFF',
                '--background': 'rgba(255,255,255,0.1)',
                '--backgroundHover': 'rgba(255,255,255,0.125)',
                '--backgroundFocus': 'rgba(148, 173, 255, 0.1)',
                '--fontSize': '12px',
                '--fontColor': '#fff',
                '--fontFamily': 'inherit',
                '--fontWeight': '500',
                '--lineHeight': '24px',
              }"
              clearable
              :placeholder="$$t('create.enter_song_title_search')"
              v-model="renderData.filterValue"
              @keyupEnter="onKeyupEnter"
              @input="onInput"
              @blur="onBlur"
              @clear="onClear"
            >
              <template #suffix v-if="createRenderType == 'mobile'">
                <Button
                  @click="onSearch"
                  :renderStyle="{
                    '--padding': '0 12px',
                    '--width': 'max-content',
                    '--height': '32px',
                    '--borderRadius': '50px',
                    '--background':
                      'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
                    '--backgroundHover':
                      'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
                    '--fontColor': '#000',
                    '--fontColorHover': '#000',
                    '--fontSize': '12px',
                    '--fontWeight': 'normal',
                    '--border': 'none',
                  }"
                >
                  {{ $$t("create.search") }}
                </Button>
              </template>
            </Search>
          </div>
          <ul
            class="generate-result-search-right-tab"
            v-if="
              renderData.listRenderType != 'createdresult' &&
              createRenderType != 'mobile'
            "
          >
            <li
              class="generate-result-search-right-tab-item pointer"
              :class="{
                'generate-result-search-right-tab-item-active':
                  renderData.listRenderType == 'mysong',
              }"
              @click="
                () => {
                  onFilterTabClick('mysong');
                }
              "
            >
              {{ $$t("create.all") }}
            </li>
            <li
              class="generate-result-search-right-tab-item pointer"
              :class="{
                'generate-result-search-right-tab-item-active':
                  renderData.listRenderType == 'likemysong',
              }"
              @click="
                () => {
                  onFilterTabClick('likemysong');
                }
              "
            >
              {{ $$t("editor.mysong_liked") }}
            </li>
            <li
              class="generate-result-search-right-tab-item pointer"
              :class="{
                'generate-result-search-right-tab-item-active':
                  renderData.listRenderType == 'publishedmysong',
              }"
              @click="
                () => {
                  onFilterTabClick('publishedmysong');
                }
              "
            >
              {{ $$t("create.mysong_published") }}
            </li>
            <li
              class="generate-result-search-right-tab-item pointer"
              :class="{
                'generate-result-search-right-tab-item-active':
                  renderData.listRenderType == 'dislikemysong',
              }"
              @click="
                () => {
                  onFilterTabClick('dislikemysong');
                }
              "
            >
              {{ $$t("editor.mysong_disliked") }}
            </li>
          </ul>
          <div
            class="generate-result-search-right-tab-mobile"
            v-if="createRenderType == 'mobile' && renderData.filterOpened"
          >
            <Select
              v-model="renderData.listRenderTypeValue"
              placement="bottom-end"
              @change="
                (val) => {
                  onFilterTabClick(val?.value);
                }
              "
              :clearable="false"
              :readonly="true"
              placeholder=""
              :options="tabSelectOptions"
            ></Select>
          </div>
          <div class="generate-result-search-title flex1">
            <div
              v-if="
                createRenderType == 'mobile' &&
                renderData.listRenderType == 'createdresult'
              "
            >
              {{ $$t("create.my_songs") }}
            </div>

            <!-- <span
              v-if="
                createRenderType == 'mobile' &&
                renderData.listRenderType == 'mysong'
              "
            >
              {{
                $$tValue("create.song_counts", {
                  num: renderData.total > 999 ? "999+" : renderData.total,
                })
              }}
            </span> -->
          </div>
        </div>
        <!-- <div class="generate-result-search-right-btn">
          <div class="generate-result-search-right-btn-close">
            <IconButton
              size="36px"
              icoSize="20px"
              backgroundColor="rgb(255, 255, 255, 0.1)"
              hoverBackgroundColor="rgb(255, 255, 255, 0.2)"
              @onClick="onToggleFilterOpenedClick"
            >
              <img src="@/assets/img/close-white-ico.png" />
            </IconButton>
          </div>
          <div class="generate-result-search-right-btn-search">
            <IconButton
              size="40px"
              icoSize="20px"
              backgroundColor="rgb(255, 255, 255, 0)"
              hoverBackgroundColor="rgb(255, 255, 255, 0.1)"
              @onClick="onToggleFilterOpenedClick"
            >
              <img src="@/assets/img/search-white-ico.png" />
            </IconButton>
          </div>
        </div> -->
      </div>
      <!-- <div
        class="generate-result-song-count-mobile"
        v-if="
          renderData.listRenderType != 'createdresult' &&
          createRenderType == 'mobile'
        "
      >
        {{
          $$tValue("create.song_counts", {
            num: renderData.total > 999 ? "999+" : renderData.total,
          })
        }}
      </div> -->
      <div
        class="generate-result-vip-acceleration flex"
        v-if="
          vipStateDataMap[renderData.vipTipState] &&
          listRenderType == 'createdresult'
        "
      >
        <i class="generate-result-vip-acceleration-ico"></i>
        <span class="generate-result-vip-acceleration-text flex1 width-0 olh">{{
          $$t(vipStateDataMap[renderData.vipTipState])
        }}</span>
        <Button
          @click="onOpenVipClick"
          :renderStyle="{
            '--padding': '0 10px',
            '--width': 'max-content',
            '--height': '24px',
            '--borderRadius': '50px',
            '--background':
              'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
            '--backgroundHover':
              'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
            '--fontColor': '#000',
            '--fontColorHover': '#000',
            '--fontSize': '12px',
            '--fontWeight': 'normal',
            '--border': 'none',
          }"
        >
          {{ $$t("create.look_for_vip") }}
        </Button>
      </div>

      <div
        class="search-result-box flex1 height-0"
        v-if="renderData.ifRenderList"
      >
        <PullTo
          ref="refPullTo"
          :initLoad="false"
          v-if="!renderData.loadError"
          :datas="renderData.datas"
          itemIdField="feed_id"
          v-model:refreshing="renderData.refreshing"
          v-model:loadingMore="renderData.loadingMore"
          v-model:isLoading="renderData.isLoading"
          v-model:finished="renderData.finished"
          @refresh="doRefresh"
          @loadMore="doLoadMore"
        >
          <template v-slot:default="slotProps">
            <div
              calss="search-result-item"
              :index="slotProps.index"
              :key="slotProps.key"
            >
              <!-- <AudioItemGenerating
                :key="`generating_${slotProps.key}`"
                :listRenderType="renderData.listRenderType"
                @from="doFrom"
                @cancel="doCancelGenerate"
                :pitem="{
                  generation_method: 2,
                  state: 2,
                }"
                :index="slotProps.index"
              ></AudioItemGenerating>
              <AudioItemGenerating
                :key="`generating_${slotProps.key}`"
                :listRenderType="renderData.listRenderType"
                @from="doFrom"
                @cancel="doCancelGenerate"
                :pitem="{
                  generation_method: 3,
                  state: 1,
                }"
                :index="slotProps.index"
              ></AudioItemGenerating> -->

              <AudioItemSuccess
                :key="`success_${slotProps.key}`"
                v-if="
                  slotProps.item.state == 3 ||
                  slotProps.item.state == 12 ||
                  (slotProps.item?.state == 2 &&
                    ModuleOpenStateControl.create.generatingStream())
                "
                :listRenderType="renderData.listRenderType"
                :index="slotProps.index"
                :pitem="slotProps.item"
                @doFrom="doFrom"
                @restore="doRestore"
              ></AudioItemSuccess>
              <AudioItemGenerating
                :key="`generating_${slotProps.key}`"
                v-if="
                  (slotProps.item?.state == 1 ||
                    (slotProps.item?.state == 2 &&
                      !ModuleOpenStateControl.create.generatingStream())) &&
                  renderData.listRenderType == 'createdresult'
                "
                :listRenderType="renderData.listRenderType"
                @from="doFrom"
                @cancel="doCancelGenerate"
                :pitem="slotProps.item"
                :index="slotProps.index"
              ></AudioItemGenerating>
              <AudioItemFailure
                :key="`failure_${slotProps.key}`"
                v-if="
                  [4, 6, 10, 11].includes(slotProps.item?.state) &&
                  renderData.listRenderType == 'createdresult'
                "
                :listRenderType="renderData.listRenderType"
                @retry="doRetryGenerate"
                @from="doFrom"
                @delete="doDeleteGenerate"
                :pitem="slotProps.item"
                :index="slotProps.index"
              ></AudioItemFailure>
              <SubscribeGuid
                v-if="
                  listRenderType == 'createdresult' &&
                  !vipStateDataMap[renderData.vipTipState] &&
                  slotProps.index == 0 &&
                  [1, 2, 3].includes(slotProps.item.state) &&
                  !slotProps.item.is_accelerated &&
                  ((globalConfig.appname == chinaAppName &&
                    userDataStore.userInfo?.user?.vip_level_name != 'pro') ||
                    (globalConfig.appname != chinaAppName &&
                      !userDataStore.userInfo?.user?.is_vip)) &&
                  feedSubscribeIsRender &&
                  ![
                    'vocal_voice',
                    'shape_melody',
                    'download_stem',
                    'generate_similar_song',
                  ].includes(abtestStore.createSubscribeGuideBarType)
                "
              ></SubscribeGuid>
              <SubscribeAbtestGuid
                v-if="
                  listRenderType == 'createdresult' &&
                  !vipStateDataMap[renderData.vipTipState] &&
                  slotProps.index == 0 &&
                  [1, 2, 3].includes(slotProps.item.state) &&
                  !slotProps.item.is_accelerated &&
                  ((globalConfig.appname == chinaAppName &&
                    userDataStore.userInfo?.user?.vip_level_name != 'pro') ||
                    (globalConfig.appname != chinaAppName &&
                      !userDataStore.userInfo?.user?.is_vip)) &&
                  feedSubscribeIsRender &&
                  [
                    'vocal_voice',
                    'shape_melody',
                    'download_stem',
                    'generate_similar_song',
                  ].includes(abtestStore.createSubscribeGuideBarType)
                "
                :type="abtestStore.createSubscribeGuideBarType"
              ></SubscribeAbtestGuid>
            </div>
          </template>
        </PullTo>
        <QueryEmptyRetry
          v-if="renderData.loadError && renderData.ifRenderEmpty"
          @retry="
            () => {
              doRetry(true);
            }
          "
        ></QueryEmptyRetry>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import message from "@/components/functionCallComponent/message.jsx";
import EmptyNoLogin from "@/page/create/feedList/emptyNoLogin.vue";
import CreateGuid from "@/page/create/createGuid/createGuid.vue";
import SubscribeGuid from "@/page/create/createGuid/subscribeGuid.vue";
import SubscribeAbtestGuid from "@/page/create/createGuid/subscribeAbtestGuid.vue";

import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import globalConfig, {
  chinaAppName,
  getGuidanceJsonDataUrl,
  ModuleOpenStateControl,
} from "@/config/config.js";

import IconButton from "@/components/basic/button/IconButton.vue";
import Button from "@/components/basic/button/Button.vue";

import { useRouter, useRoute } from "vue-router";
import Search from "@/components/basic/input/Search.vue";
import AudioItemSuccess from "./audioItemSuccess.vue";
import AudioItemGenerating from "./audioItemGenerating.vue";
import AudioItemFailure from "./audioItemFailure.vue";
import QueryEmptyRetry from "@/components/basic/pullTo/queryEmptyRetry.vue";
import { storeToRefs } from "pinia";
import tools from "@/utils/tools.js";

import feedListApi from "@/api/api/feedListApi.js";

import PullTo from "@/components/basic/pullTo/PullTo.vue";
import useFeedListStore from "@/store/create/feedListDataStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js";
import useAbtestStore from "@/store/abtestStore.js";

import { payOrder, checkSongOrder } from "@/api/api/apiCommon.js";
import usePresetSourceDataStore from "@/store/create/presetSourceDataStore.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType, createEditMode, feedSubscribeIsRender } =
  storeToRefs(createLayoutStore);

const feedListDataStore = useFeedListStore();
const userDataStore = useUserDataStore();
const globalPlayDataStore = useGlobalPlayDataStore();
const presetSourceDataStore = usePresetSourceDataStore();
const abtestStore = useAbtestStore();
const { $$language, $$t, $$tm, $$tValue } =
  getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {};

const globalProperties = (
  getCurrentInstance() || window?.$getVueCurrentInstance?.()
).appContext.config.globalProperties;

const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
  .appContext?.config?.globalProperties?.$router;
const route = useRoute();

const props = defineProps({
  listRenderType: {
    type: String,
    default: "createdresult", // mysong, likemysong, createdresult publishedmysong
  },
});

const tabSelectOptions = [
  {
    label: $$t("create.all"),
    value: props.listRenderType,
  },
  {
    label: $$t("editor.mysong_liked"),
    value: "likemysong",
  },
  {
    label: $$t("create.mysong_published"),
    value: "publishedmysong",
  },
  {
    label: $$t("editor.mysong_disliked"),
    value: "dislikemysong",
  },
];

const isCreatePage = computed(() => {
  return ["create", "createIndex"].includes(route.name);
});

const emits = defineEmits(["restore"]);
const refExtendSong = ref(null);
const refPullTo = ref(null);
const refSearchInput = ref(null);

const vipStateDataMap = {
  true__1: "create.generate_vip__queue",
  true__0: "create.not_vip__not_queue",
  false__1: "create.generate_not__vip_queue",
  false__2: "create.generate_not_vip__not_queue",
};

const getEmptyInfo = () => {
  switch (renderData.listRenderType) {
    case "mysong":
      return {
        networkerror: $$t("common.network_error"),
        loadfailure: $$t("common.load_failure"),
        contentviolation: $$t("common.content_violation"),
        emptydata: $$t("create.liked_my_song_empty"),
      };
    case "likemysong":
      return {
        networkerror: $$t("common.network_error"),
        loadfailure: $$t("common.load_failure"),
        contentviolation: $$t("common.content_violation"),
        emptydata: $$t("create.my_song_empty"),
      };
    case "createdresult":
      return {
        networkerror: $$t("common.network_error"),
        loadfailure: $$t("common.load_failure"),
        contentviolation: $$t("common.content_violation"),
        emptydata: $$t("create.generated_song_empty"),
      };
    case "publishedmysong":
      return {
        networkerror: $$t("common.network_error"),
        loadfailure: $$t("common.load_failure"),
        contentviolation: $$t("common.content_violation"),
        emptydata: $$t("create.generated_song_empty"),
      };
    case "dislikemysong":
      return {
        networkerror: $$t("common.network_error"),
        loadfailure: $$t("common.load_failure"),
        contentviolation: $$t("common.content_violation"),
        emptydata: $$t("create.generated_song_empty"),
      };
    default:
      return {
        networkerror: $$t("common.network_error"),
        loadfailure: $$t("common.load_failure"),
        contentviolation: $$t("common.content_violation"),
        emptydata: $$t("create.generated_song_empty"),
      };
  }
};

const renderData = reactive({
  filterOpened: true,

  filterValue: "",
  hasInit: false,
  datas: [],
  refreshing: false,
  loadingMore: false,
  isLoading: false,
  loadError: false,
  finished: false,
  demoSongData: null,
  ifRender: true,
  total: 0,
  vipTipState: null,
  ifRenderList: true,
  emptyInfo: null,
  ifRenderEmpty: true,
});

const reRenderList = () => {
  renderData.ifRenderList = false;
  nextTick(() => {
    renderData.ifRenderList = true;
  });
};

const isDoEditSong = computed(() => {
  return renderData.extendSongDialogVisible || renderData.editSongDialogVisible;
});

const onToggleFilterOpenedClick = () => {
  renderData.filterOpened = !renderData.filterOpened;
  if (!renderData.filterOpened) {
    renderData.filterValue = "";

    if (props.listRenderType == "mysong") {
      renderData.listRenderType = feedListDataStore.mysongLastTab;
    } else {
      renderData.listRenderType = props.listRenderType;
    }

    renderData.listRenderTypeValue = getListRenderTypeValue(
      props.listRenderType
    );
    console.log("onToggleFilterOpenedClick", 11, renderData.filterValue);
    refPullTo.value?.initUpScroll();
    doRetry();
  } else {
    nextTick(() => {
      refSearchInput.value?.focus();
    });
  }
};

// const getDemoSongData = () => {
//   return new Promise((resolve, reject) => {
//     presetSourceDataStore.getPresetSourceData().then((data) => {
//       renderData.demoSongData = data.web_song_showcase;
//     })
//   })
// };

const onKeyupEnter = () => {
  refPullTo.value?.initUpScroll();
  doRetry();
};
const onSearch = (val) => {
  refPullTo.value?.initUpScroll();
  doRetry();
};

const onBlur = (e) => {
  setTimeout(() => {
    nextTick(() => {
      refPullTo.value?.initUpScroll();
    }).then(() => {
      console.log("onToggleFilterOpenedClick", 22, renderData.filterValue);
      doRetry();
    });
  }, 10);
};

const onInput = (val) => {
  renderData.filterValue = val;
  // doRetry();
};
const onClear = () => {
  renderData.filterValue = "";
  refPullTo.value?.initUpScroll();
  doRetry();
};

const onFilterTabClick = (tab) => {
  if (renderData.listRenderType !== tab) {
    renderData.listRenderType = tab;
    renderData.datas = [];
    renderData.total = 0;
    refPullTo.value?.initUpScroll();
    feedListDataStore.setMysongTab(tab);
    doRetry();
  }
};
const getQueryParams = () => {
  let params = null;
  // 1-只包含生成成功的歌曲,2-收藏自己的歌曲，3-已发布的歌曲
  switch (renderData.listRenderType) {
    case "mysong":
      params = {
        t: 1,
        title: renderData.filterValue ?? "",
        query_type: "mysong",
      };
      break;
    case "likemysong":
      params = {
        t: 2,
        size: 20,
        title: renderData.filterValue ?? "",
        query_type: "likemysong",
      };
      break;
    case "publishedmysong":
      params = {
        t: 3,
        size: 20,
        title: renderData.filterValue ?? "",
        query_type: "publishedmysong",
      };
      break;
    case "dislikemysong":
      params = {
        t: 4,
        size: 20,
        title: renderData.filterValue ?? "",
        query_type: "dislikemysong",
      };
      break;
    case "createdresult":
      params = {
        title: renderData.filterValue ?? "",
      };
      break;
    default:
      params = {};
  }
  return {
    listRenderType: renderData.listRenderType,
    title: renderData.filterValue ?? "",
    ...params,
  };
};

const doRefresh = (done, errodone) => {
  renderData.isLoading = true;
  feedListDataStore.refresh(
    getQueryParams(),
    (...args) => {
      renderData.finished = args[1] ?? true;
      renderData.isLoading = false;
      renderData.loadError = false;
      done(...args);
    },
    (...args) => {
      renderData.isLoading = false;
      renderData.loadError = true;
      errodone(...args);
    }
  );
};

const doLoadMore = (done, errodone) => {
  renderData.isLoading = true;
  feedListDataStore
    .loadMore(
      (...args) => {
        renderData.finished = args[1] ?? true;
        renderData.isLoading = false;
        done(...args);
      },
      (...args) => {
        renderData.isLoading = false;
        errodone(...args);
      },
      renderData.listRenderType
    )
    .then(() => {})
    .catch((err) => {
      console.error("loadMore error", err);
    });
};

const doRetry = (isRetry) => {
  if (renderData.isLoading) {
    return;
  }
  const params = getQueryParams();
  renderData.isLoading = true;
  feedListDataStore.init(
    params,
    (...args) => {
      renderData.finished = args[1] ?? true;
      renderData.isLoading = false;
      renderData.loadError = false;
      if (!params.title) {
        if (!args[0].length) {
          renderData.hasInit = false;
        } else {
          renderData.hasInit = true;
        }
      } else {
        renderData.hasInit = true;
      }
    },
    (...args) => {
      renderData.loadError = true;
      renderData.isLoading = false;
    }
  );
};

const refFeedList = ref(null);

const onCloseVipClick = () => {
  feedListDataStore.setVipTipVisible(false);
};
const onOpenVipClick = () => {
  Router.push({
    name: "subscribe",
    membership_source1: "create",
    membership_source2: "generateNotVipInQueue",
  });
  globalProperties?.logClickEvent("create_skip_queue", {});
};

const doRestore = (pitem, item) => {
  emits("restore", pitem, item);
};

const doFrom = (pitem, item) => {
  feedListDataStore.doFrom(pitem, item);
};

const doRetryGenerate = (pitem, item, cb) => {
  cb?.(true);
  feedListDataStore
    .doRetryGenerate(pitem, item)
    .then(() => {
      cb?.(false);
    })
    .catch(() => {
      cb?.(false);
    });
};

const doCancelGenerate = (pitem, item) => {
  feedListDataStore.doCancelGenerate(pitem, item);
};
const doDeleteGenerate = (pitem, item) => {
  feedListDataStore.doDeleteGenerate(pitem, item);
};

const setRenderDataVipTipState = () => {
  if (
    renderData.datas.length > 0 &&
    [1, 2].includes(renderData.datas[0]?.state)
  ) {
    let state = `${renderData.datas[0].is_accelerated || false}__${
      renderData.datas[0].state
    }`;
    if (state == "false__1") {
      renderData.vipTipState = state;
      globalProperties?.logViewEvent("create_skip_queue", {});
    } else {
      renderData.vipTipState = "";
    }
  } else {
    renderData.vipTipState = "";
  }
};

const setRenderDatas = () => {
  switch (renderData.listRenderType) {
    case "createdresult":
      renderData.datas = feedListDataStore.feedlist_createdresult ?? [];
      renderData.total = feedListDataStore.total_createdresult ?? 0;
      break;
    case "mysong":
      renderData.datas = feedListDataStore.feedlist_mysong ?? [];
      renderData.total = feedListDataStore.total_mysong ?? 0;
      break;
    case "likemysong":
      renderData.datas = feedListDataStore.feedlist_likemysong ?? [];
      renderData.total = feedListDataStore.total_likemysong ?? 0;
      break;
    case "dislikemysong":
      renderData.datas = feedListDataStore.feedlist_dislikemysong ?? [];
      renderData.total = feedListDataStore.total_dislikemysong ?? 0;
      break;
    case "publishedmysong":
      renderData.datas = feedListDataStore.feedlist_publishedmysong ?? [];
      renderData.total = feedListDataStore.total_publishedmysong ?? 0;
      break;
    default:
      renderData.datas = feedListDataStore.feedlist_createdresult ?? [];
      renderData.total = feedListDataStore.total_createdresult ?? 0;
      break;
  }
  setRenderDataVipTipState();
  // reRenderList();
};
const reRender = () => {
  renderData.ifRender = false;
  nextTick(() => {
    renderData.ifRender = true;
  });
};
watch(
  () => createRenderType.value,
  (newVal, oldVal) => {
    reRender();
  }
);

watch(
  () => feedListDataStore.feedlist_createdresult,
  (newVal, oldVal) => {
    setRenderDatas();
  }
);
watch(
  () => feedListDataStore.feedlist_mysong,
  (newVal, oldVal) => {
    setRenderDatas();
  }
);
watch(
  () => feedListDataStore.feedlist_likemysong,
  (newVal, oldVal) => {
    setRenderDatas();
  }
);
watch(
  () => feedListDataStore.feedlist_dislikemysong,
  (newVal, oldVal) => {
    setRenderDatas();
  }
);

watch(
  () => feedListDataStore.feedlist_publishedmysong,
  (newVal, oldVal) => {
    setRenderDatas();
  }
);

watch(
  () => isDoEditSong.value,
  (newValue) => {
    doTempToggleGlobalPlay(isDoEditSong.value);
  }
);

watch(
  () => {
    return feedListDataStore.libraryListRenderTypeScamp;
  },
  (newVal) => {
    if (createRenderType.value == "mobile") {
      renderData.filterValue  = ''
      renderData.listRenderType = "createdresult";
      renderData.listRenderTypeValue = getListRenderTypeValue(
        renderData.listRenderType
      );
    }
  }
);

watch(
  () => {
    return userDataStore.isLogin;
  },
  () => {
    if (userDataStore.isLogin) {
      doRetry();
    } else {
      renderData.hasInit = false;
      // getDemoSongData();
    }
  }
);

const getListRenderTypeValue = (type) => {
  return tabSelectOptions.filter((item) => item.value == type)[0] ?? null;
};

const initDemoData = () => {
  if (presetSourceDataStore.presetSourceData) {
    renderData.demoSongData =
      presetSourceDataStore.presetSourceData.web_song_showcase;
  }
};

watch(
  () => {
    return presetSourceDataStore.presetSourceData;
  },
  () => {
    initDemoData();
  }
);

watch(
  () => userDataStore.appLanguage,
  (newVal) => {
    nextTick().then(() => {
      renderData.emptyInfo = getEmptyInfo();
      // renderData.ifRenderEmpty = false;
      // nextTick(() => {
      //   renderData.ifRenderEmpty = true;
      // });
    });
  }
);

onMounted(() => {
  nextTick(() => {
    renderData.mounted = true;
  });
  initDemoData();
  renderData.emptyInfo = getEmptyInfo();
  if (props.listRenderType == "mysong" && createRenderType.value == "mobile") {
    renderData.listRenderType = "createdresult";
  } else {
    renderData.listRenderType = props.listRenderType;
  }
  setRenderDatas();
  // if (!userDataStore.isLogin) {
  //   getDemoSongData();
  // }

  renderData.listRenderTypeValue = getListRenderTypeValue(
    renderData.listRenderType
  );

  if (!userDataStore.isLogin) {
    renderData.hasInit = false;
    return;
  }
  doRetry();
});
</script>
<style lang="scss">
.generate-result {
  .generate-result-main {
    display: flex;
    flex-direction: column;
  }
  .generate-result-search {
    padding: 19px 20px 10px 20px;
    align-items: center;
  }
  .generate-result-search-search {
    width: 100%;
    height: 38px;
  }
  .generate-result-search-right-tab {
    margin: 0 0 0 12px;
    height: 40px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 40px;
    font-size: 14px;
    font-weight: normal;
    line-height: 40px;

    color: rgba(255, 255, 255, 0.5);
    .generate-result-search-right-tab-item {
      height: 40px;
      width: 92px;
      display: inline-block;
      vertical-align: middle;
      line-height: 40px;
      text-align: center;
      border-radius: 40px;
      &:hover {
        color: #ffffff;
      }
      &.generate-result-search-right-tab-item-active {
        font-weight: bold;
        color: #ffffff;
        background: rgba(255, 255, 255, 0.1);
      }
    }
  }
  .generate-result-search-right-tab-mobile {
    margin: 0 0 0 8px;
    .custom-select {
      width: unset;
      min-width: max-content;
      height: 36px;
      .el-select {
        height: 36px;
      }
      .el-select__wrapper {
        width: unset;
        min-width: max-content;
        display: block;
        height: 36px;
        padding: 4px 12px;
      }
      .el-select__input-wrapper.is-hidden {
        width: 0;
        height: 0;
        overflow: hidden;
        .el-select__input {
          width: 0 !important;
          height: 0 !important;
        }
      }
      .el-select__selection {
        width: unset;
        display: inline-block;
        vertical-align: middle;
        min-width: max-content;
      }
      .el-select__selected-item {
        min-width: max-content;
        position: unset;
        transform: unset;
      }
      .el-select__suffix {
        display: inline-block;
        vertical-align: middle;
        transform: unset;
        height: 16px;
        margin: 0 0 0 8px;
      }
    }
  }
  .generate-result-search-right-btn {
    margin: 0 0px 0 8px;
    display: none;
  }
  .generate-result-search-title {
    font-family: HarmonyOS Sans SC;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    color: #ffffff;
    display: none;
  }
  .generate-result-song-count-mobile {
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    color: #ffffff;
    margin: 0px 16px 4px 16px;
    opacity: 0.8;
  }
  .generate-result-search-title-count {
    font-family: HarmonyOS Sans SC;
    height: 40px;
    font-size: 16px;
    font-weight: 500;
    line-height: 40px;
    color: #fff;
    padding-left: 0;
    display: none;
    margin-right: 12px;
  }

  .generate-result-vip-acceleration {
    height: 32px;
    border-radius: 30px;
    display: flex;
    align-items: center;
    padding: 4px 4px 4px 12px;
    background: rgba(255, 255, 255, 0.2);
    margin: 12px 18px 6px 18px;
    .generate-result-vip-acceleration-ico {
      height: 20px;
      width: 20px;
      background: url("@/assets/img/vip-acceleration-ico.png");
      background-size: 100% 100%;
    }
    .generate-result-vip-acceleration-text {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 24px;
      background: #94adff;
      background-clip: text;
      color: transparent;
      background-clip: text;
      margin: 0 24px 0 12px;
    }
  }

  .search-result-box {
  }
  .search-result-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    i {
      height: 200px;
      width: 270px;
      background: url("@/assets/img/empty-ico.png");
      background-size: 100% 100%;
    }
    p {
      display: none;
      margin-top: -30px;
      font-family: HarmonyOS Sans SC;
      font-size: 18px;
      font-weight: normal;
      line-height: 22px;
      text-align: center;
      color: #ffffff;
    }
  }
  &.generate-result--likemysong,
  &.generate-result--dislikemysong,
  &.generate-result--mysong,
  &.generate-result--publishedmysong {
    .search-result-box {
      padding: 0 0;
    }
    .generate-result-search {
      padding: 0 20px 10px 20px;
    }
  }
  &.generate-result--pc {
    .generate-result-search-title-count {
      display: block;
    }
    .generate-result-search-search-box {
      flex-direction: row-reverse;
      justify-content: space-between;
    }
    .generate-result-search-search {
      height: 40px;
      max-width: 100%;
    }
    .generate-result-search-right-tab {
      margin: 0;
      background: transparent;
      .generate-result-search-right-tab-item {
        line-height: 30px;
        height: 32px;
        font-size: 14px;
        margin: 0 25px 0 0;
        width: unset;
        border-bottom: 2px solid transparent;
        color: rgba(255, 255, 255, 0.5);
        &:hover {
          color: #fff;
        }
        &.generate-result-search-right-tab-item-active {
          background: transparent;
          border-radius: 0;
          border-bottom: 2px solid #fff;
          color: #fff;
          font-weight: 500;
        }
      }
    }
    &.generate-result--likemysong,
    &.generate-result--dislikemysong,
    &.generate-result--mysong,
    &.generate-result--publishedmysong {
      .generate-result-search-search {
        max-width: 400px;
      }
    }
  }
  &.generate-result--mobile {
    &.generate-result--likemysong,
    &.generate-result--dislikemysong,
    &.generate-result--mysong,
    &.generate-result--publishedmysong {
      .search-result-box {
        padding: 0 0;
      }
      &.generate-result--pc {
        .generate-result-search-search {
          max-width: 100%;
        }
      }
    }
    &.generate-result--createdresult {
      // padding-bottom: 80px;
    }
    .generate-result-vip-acceleration {
      margin: 4px 16px 12px 16px;
    }
    .generate-result-search {
      padding: 0px 16px 8px 16px;
      height: 54px;
    }
    .generate-result-search-right-btn {
      display: block;
    }
    .generate-result-search--opened {
      .generate-result-search-search {
        display: block;
        height: 36px;
      }
      .generate-result-search-right-btn-close {
        display: block;
      }
      .generate-result-search-title {
        display: none;
      }
      .generate-result-search-right-btn-search {
        display: none;
      }
    }
    .generate-result-search--closed {
      .generate-result-search-search {
        display: none;
      }
      .generate-result-search-right-btn-close {
        display: none;
      }
      .generate-result-search-title {
        display: block;
      }
      .generate-result-search-right-btn-search {
        display: block;
      }
    }
  }
}
</style>
